import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";

export default function UserTypeSelectPopover({
  value,
  onValueChange,
  internalUserTypes,
  externalUserTypes,
  onClose,
  onSearch,
  onClear,
}) {
  return (
    <Box sx={{ minWidth: 200, width: 280 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1.5,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold", color: "#111827" }}>
          Filter User Type
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ p: 0.5 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: "#627CFB",
          mb: 1.5,
          fontSize: "0.875rem",
        }}
      >
        User Type
      </Typography>

      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel sx={{ color: "#9CA3AF", fontSize: "0.875rem" }}>
          Select User Type
        </InputLabel>
        <Select
          value={value || ""}
          onChange={(e) => onValueChange(e.target.value)}
          label="Select User Type"
          IconComponent={ExpandMoreIcon}
          renderValue={(selected) => (
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              {selected || "Select User Type"}
            </Typography>
          )}
          sx={{
            fontSize: "0.875rem",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#D1D5DB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#627CFB",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#627CFB",
              borderWidth: "2px",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 400,
                zIndex: 99999,
              },
            },
            style: {
              zIndex: 99999,
            },
          }}
        >
          <MenuItem disabled sx={{ opacity: 1, cursor: "default" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1 }}>
              <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 500 }}>
                Internal
              </Typography>
              <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db" }} />
            </Box>
          </MenuItem>
          {internalUserTypes.map((type) => (
            <MenuItem
              key={type}
              value={type}
              sx={{
                display: "flex",
                alignItems: "center",
                py: 1,
                px: 2,
                "&:hover": {
                  backgroundColor: "#F3F4F6",
                },
              }}
            >
              <Checkbox
                checked={(value || "") === type}
                disableRipple
                sx={{
                  p: 0,
                  mr: 1.5,
                  "&.Mui-checked": {
                    color: "#627CFB",
                  },
                }}
              />
              <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                {type}
              </Typography>
            </MenuItem>
          ))}

          <MenuItem disabled sx={{ opacity: 1, cursor: "default", mt: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1 }}>
              <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 500 }}>
                External
              </Typography>
              <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db" }} />
            </Box>
          </MenuItem>
          {externalUserTypes.map((type) => (
            <MenuItem
              key={type}
              value={type}
              sx={{
                display: "flex",
                alignItems: "center",
                py: 1,
                px: 2,
                "&:hover": {
                  backgroundColor: "#F3F4F6",
                },
              }}
            >
              <Checkbox
                checked={(value || "") === type}
                disableRipple
                sx={{
                  p: 0,
                  mr: 1.5,
                  "&.Mui-checked": {
                    color: "#627CFB",
                  },
                }}
              />
              <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                {type}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        onClick={onSearch}
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: "#627CFB",
          color: "white",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.875rem",
          mb: 1,
          "&:hover": {
            backgroundColor: "#536DEC",
          },
        }}
      >
        Search
      </Button>

      {value && (
        <Button
          onClick={onClear}
          size="small"
          fullWidth
          sx={{
            color: "#627CFB",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            "&:hover": {
              backgroundColor: "rgba(98, 124, 251, 0.04)",
            },
          }}
        >
          Clear Filter
        </Button>
      )}
    </Box>
  );
}
